import CustomButton from "../components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";

const Confirmation = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <div className="px-5 pt-28 relative">
      <div className="text-center mb-7">
        <div className="text-3xl font-semibold mb-3">Thank you!</div>
        <p className="text-lg">
          Thank you for your request! We’ve received your call-back request, and
          one of our MyToyota Insurance Representatives will contact you
          shortly. <br />
          Thank you for your patience!
        </p>
      </div>
      <div className="py-5">
        <CustomButton onClick={() => navigate(`/${state?.customerId}`)}>
          Back to start
        </CustomButton>
      </div>
    </div>
  );
};

export default Confirmation;
